import { render, staticRenderFns } from "./ShareholderDirectorForm.vue?vue&type=template&id=4b72f09d&"
import script from "./ShareholderDirectorForm.vue?vue&type=script&lang=js&"
export * from "./ShareholderDirectorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports